export const iconFontAwesomeMoneySackXmark = (
	<i className="fa-solid fa-sack-xmark"></i>
);
